var _rect, _rect2, _rect3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStsIntroSeated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 291,
    viewBox: "10 20 170 225",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 58,
    width: 8,
    height: 182,
    rx: 2,
    fill: "#7D7D7D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 151,
    width: 96,
    height: 9,
    rx: 2,
    fill: "#7D7D7D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 160,
    width: 7,
    height: 80,
    rx: 2,
    fill: "#7D7D7D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#E9E9E9",
    stroke: "#8F8F8F",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 226,
    width: 36,
    height: 14,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 146,
    width: 16,
    height: 86,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 132,
    width: 62,
    height: 19,
    rx: 9.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 66,
    cy: 139,
    rx: 17,
    ry: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 92 Q50 84 60 82 L74 82 Q84 84 82 94 L78 124 Q76 130 68 130 L62 130 Q55 130 54 124 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 70,
    width: 9,
    height: 14,
    rx: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 68,
    cy: 54,
    rx: 14,
    ry: 18,
    transform: "rotate(8 68 54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 92,
    width: 12,
    height: 38,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 122,
    width: 40,
    height: 11,
    rx: 5.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108,
    cy: 127,
    rx: 7,
    ry: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 93,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 128,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 142,
    r: 8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStsIntroSeated);
export default __webpack_public_path__ + "static/media/sts-intro-seated.dfb9748aca10dc7e7f84c03a66e0fd56.svg";
export { ForwardRef as ReactComponent };